import { Inplace, InplaceContent, InplaceDisplay } from "primereact/inplace";
import "./inline-block.scss";
import { ReactNode } from "react";

export interface InlineBlockProps {
  disabled?: boolean;
  children?: ReactNode;
  label?: string;
  value?: string;
  hint?: string;
}

export function InlineBlock({
  disabled,
  children,
  label,
  value,
  hint,
}: InlineBlockProps) {
  return (
    <div id="InlineBlock" className="inline-block">
      <Inplace
        disabled={disabled}
        closable
        id="service"
        className="flex items-center"
      >
        <InplaceDisplay>
          <div className="flex flex-col">
            {value ? (
              <span className="border-b border-b-gray-400 font-bold">
                {value}
              </span>
            ) : (
              <span className="border-b border-b-gray-400 font-bold">
                {hint}
              </span>
            )}
            <div>{label}</div>
          </div>
        </InplaceDisplay>
        <InplaceContent>
          <div className="float-start">{children}</div>
        </InplaceContent>
      </Inplace>
    </div>
  );
}

export default InlineBlock;
